import { h, Fragment } from "preact";
import { useMemo } from "preact/hooks";
import ProductOptionSwatch from "./product-option-swatch";
import sortMaterials from "../../helpers/sortMaterials/sortMaterials";
import sanitizeOptionValue from "../../helpers/sanitizeOptionValue";

export default function ProductOptionSwatchesGrouped({
  optionValues,
  optionName,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues = [],
}) {
  const optionsByGroup = useMemo(() => {
    const groups = {};
    optionValues.forEach((optionValue) => {
      if (!optionValue.materialGroup) {
        // Group any missing groups under the option name
        optionValue.materialGroup = optionName;
      }

      if (!(optionValue.materialGroup in groups)) {
        groups[optionValue.materialGroup] = [];
      }

      groups[optionValue.materialGroup].push(optionValue);
    });

    return groups;
  }, [optionValues, optionName]);

  return (
    <div className="product-options__swatches-grouped">
      <div className="product-options__name">{optionName}</div>
      <div className="product-options__selected-value">
        {sanitizeOptionValue(selectedOptionValue)}
      </div>
      <div className="product-options__swatch-groups">
        {Object.entries(optionsByGroup)
          .sort(([groupA], [groupB]) => sortMaterials(groupA, groupB))
          .map(([groupTitle, optionValues]) => (
            <div className="product-options__swatch-group">
              <div className="product-options__swatch-group-title">
                {groupTitle}
              </div>
              <div className="product-options__swatch-list">
                {optionValues.map((optionValue) => (
                  <ProductOptionSwatch
                    key={optionValue.name}
                    optionValue={optionValue}
                    optionName={optionName}
                    disabled={disabledOptionValues.includes(optionValue.name)}
                    updateOptionValue={updateOptionValue}
                    selected={optionValue.name === selectedOptionValue}
                  />
                ))}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
